module.exports = __webpack_public_path__ + "static/media/zhongxuanzhong@3x.dc66a268.png";